import React from "react";

interface IStepsProgressBarProps {
    stepsCount: number;
    currentStep: number;
}

const StepsProgressBar = (props: IStepsProgressBarProps) => {
    return (
        <div className="flex-container progress-bar-container">
            <div className="forms">
                <div className="progress-bar">
                    {Array.from({ length: props.stepsCount }, (_, index) => (
                        <React.Fragment key={`step-${index}`}>
                            <div className={`step ${index + 1 > props.currentStep ? "step-inactive" : ""}`}>
                                {(index + 1 === props.currentStep) && (
                                    <div className="step-inner step-circle">
                                        &#183;
                                    </div>
                                )}

                                {(index + 1 < props.currentStep) && (
                                    <div className="step-inner step-tick">
                                        &#x2714;
                                    </div>
                                )}
                            </div>
                            {(index < props.stepsCount - 1) && (
                                <div className={`line ${props.currentStep > index + 1 ? "line-active" : ""}`}></div>
                            )}
                        </React.Fragment>
                    ))}
                </div>
                {/* add another div below .progress-bar - <p> tags with space between each other (the same space as the width of the horizontal line) */}
            </div>
        </div>
    );
};

export default StepsProgressBar;